// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"9c49c3b0","483":"efea1b4d","496":"cd84cc2f","498":"034c0949","703":"d18f5bf7"}[chunkId] + ".chunk.js";
};